import { render, staticRenderFns } from "./userDetailsContent.vue?vue&type=template&id=6206b08c&scoped=true"
import script from "./userDetailsContent.vue?vue&type=script&lang=js"
export * from "./userDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206b08c",
  null
  
)

export default component.exports